var helperCreateInInObjectString = require('./helperCreateInInObjectString')

/**
  * 判断是否数组
  *
  * @param {Object} obj 对象
  * @return {Boolean}
  */
var isArray = Array.isArray || helperCreateInInObjectString('Array')

module.exports = isArray



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/isArray.js
// module id = nvJ/
// module chunks = 137